<style lang="less">
.order_detail{
	.detail{
		height: auto;
		overflow: hidden;
		padding: 0 0 0 0;
		position: relative;
		border-radius: 3px 3px 0 0;
		.head{
			min-height: 133px;
			background: #fff;
			display: -webkit-box; display:flex;
			-webkit-box-align: center; align-items: center;
			-webkit-box-pack: center; justify-content: center;
			flex-direction: column;
			padding: 20px 0;
			p{
				padding-bottom: 6px;
				font-size: 14px;
				font-weight: 500;
			}
			h3{
				padding-bottom: 7px;
				font-size: 30px;
				font-weight: 700;
				color: #dc2a2a;
				span{
					font-size: 16px;
					padding-right: 4px;
				}
			}
			.status{
				color: #999;
				font-size: 12px;
				font-weight: 400;
			}
			.warm{
				color: #dc2a2a;;
			}
		}
		.info{
			background: #fff;
			padding: 10px 24px 44px 24px;
			.item{
				line-height: 16px;
				font-size: 12px;
				padding-top: 21px;
				overflow: hidden;
				label{
					color: #999;
					float: left;
				}
				p{
					color: #000;
					float: right;
				}
			}
		}
	}
	.deal_line{
		width: 125px;
		height: 6px;
		background: #c62520;
		position: absolute;
		left: 32px;
		top: 30px;
	}
	.day{
		.deal_line{
			width: 128px;
		}
		.item{
			padding-top: 2px;
			p{
				font-size: 10px;
				color: #666;
				font-weight: 400;
			}
		}
	}
	.line{
		height: 1px;
		background: #e5e5e5;
		width: 328px;
		margin: 0 auto;
		transform: scale(1, 0.5);
	}

	.takeout{
		.head{
			h3{
				color: #2e4276;
			}
		}
	}
}
</style>

<template>
	<!-- Main order_detail -->
	<section class="order_detail">
		<div :class="detail.bal_offset_type == 4 ? 'detail charge' : 'detail takeout'">
			<div class="head">
				<p>{{detail.subject || (type_list[detail.orderType] || '' )}}</p>
				<h3 class="NOFont"><!-- {{detail.bal_offset_type == 4 ? '+' : '-'}} -->{{detail.pay_amt.Format()}} <span>元</span></h3>
				<div :class="detail.order_status == 8 ? 'status warm' : 'status' ">{{detail.order_status_remark}}</div>
			</div>
			<div class="line"></div>
			<div class="info">
				<div class="item">
					<label>订单号</label>
					<p>{{detail.order_id}}</p>
				</div>
				<template v-if="detail.order_status != 128">
					<div class="item" v-if="detail.order_type == 10">
						<label>支付方式</label>
						<p>{{ detail.pay_channel_result_info.pay_channel_type == 0 ? detail.pay_channel_result_info.pay_channel_info.bank_name + ' ' + detail.pay_channel_result_info.pay_channel_info.bacc_no_l4 : config.pay_channel_type[detail.pay_channel_result_info.pay_channel_type] }}</p>
					</div>
				</template>
				<div class="item">
					<label>操作时间</label>
					<p>{{detail.day}}</p>
				</div>
				<template v-if="detail.order_status != 128">
					<div class="item" v-if="detail.order_type == 20">
						<label>资金去向</label>
						<p>{{detail.pay_channel_result_info.pay_channel_info.bank_name}} {{detail.pay_channel_result_info.pay_channel_info.bacc_no_l4}}</p>
					</div>
					<template v-if="detail.actual_order_type == 20 || detail.actual_order_type == 22">
						<div class="item" v-if="detail.pay_channel_result_info.value_date">
							<label>起息时间</label>
							<p>{{new Date(detail.pay_channel_result_info.value_date).Format("yyyy/MM/dd")}}</p>
						</div>
						<div class="item" v-if="detail.pay_channel_result_info.rec_value_date">
							<label>收益到账</label>
							<p>预计 {{new Date(detail.pay_channel_result_info.rec_value_date).Format("yyyy/MM/dd")}}</p>
						</div>
					</template>
					<div class="item" v-if="detail.actual_order_type == 21">
						<label>到账时间</label>
						<p v-if="detail.pay_channel_result_info.redeem_type == 't_0'">2小时内到账</p>
						<p v-else>预计 {{new Date(detail.pay_channel_result_info.pred_cash_time).Format("MM 月 dd 日")}}到账</p>
					</div>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
	import axios from '../axios.js';
	import apis from '../apis.js';
	import config from '../config.js';

	export default {
		data: function () {
			return {
				config: config,
				type_list: {},
				detail: {
					pay_channel_result_info: {}
				}
			};
		},
		computed: {
			order_type_txt: function () {
				let txt = '';
				switch (this.detail.order_type){
					case 10:
						txt = '转入成功';
						break;
					case 20:
						txt = '转出成功';
						break;
				}
				return txt;
			}
		},
		components: {
		},
		created: function () {
			this.getTypeList();
			this.getDetail();
		},
		mounted: function () {
		},
		update: function () {
		},
		beforeDestroy: function () {
			document.body.style.background = "none";
		},
		methods: {
			getTypeList: function () {
				let _this = this;
				axios.post(apis.order_type, {}).then(function(d) {
					console.log('order_type', d);
					var t_data = d.value.order_type_infos;
					for( var i in t_data) {
						_this.type_list[t_data[i].value] = t_data[i].desc;
					}
				});
			},
			getDetail: function () {
				let _this = this;
				axios.post(apis.order_detail, {
					order_id: _this.$route.query.id
				}).then(function(d) {
					console.log('order_detail', d, d.value.pay_channel_result_info);
					_this.detail = d.value;
					d.value.day = new Date(d.value.create_time).Format("yyyy/MM/dd hh:mm:ss");
				});
			},
		}
	};
</script>


// WEBPACK FOOTER //
// src/pages/Order_detail.vue